interface SelectFieldOption {
  label: string;
  value: string;
}

interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  options: SelectFieldOption[];
  disabled?: boolean;
  statusText?: string;
  onChange?: (value: string) => void;
}

export const SelectField = ({ disabled, id, label, onChange, options, statusText, value }: SelectFieldProps) => {
  return (
    <label className="flex flex-col gap-1 text-sm font-semibold text-neutral-foreground" htmlFor={id}>
      {label}
      <select
        className="rounded-sm border border-border-neutral bg-raised px-3 py-2 font-ui text-sm text-neutral-foreground disabled:bg-disabled disabled:text-disabled-foreground"
        disabled={disabled}
        id={id}
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {statusText && <span className="text-sm font-normal text-critical-foreground">{statusText}</span>}
    </label>
  );
}
